






import { Component, Watch, Vue } from 'vue-property-decorator';
import SelectBillItems from '@/components/bill/SelectBillItems.vue';
import SelectShipment from '@/components/bill/SelectShipment.vue';

@Component({
  components: {
    SelectBillItems,
    SelectShipment
  }
})
export default class BillNew extends Vue {
  private isSelecting = false;

  private selectedShipmentIds: string[] = [];

  private selectItems(shipmentIds: string[]): void {
    this.selectedShipmentIds = shipmentIds;
    this.isSelecting = true;
  }

  private revert(value: any): void {
    this.isSelecting = false;
  }
}
